// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CodeStatusService } from '../../code-status.service';
import { GetCodeStatusList } from './code-status.actions';
import { CODE_STATUS_STATE_DEFAULT, CodeStatusStateModel } from './code-status.model';

@State({ name: 'CodeStatus', defaults: CODE_STATUS_STATE_DEFAULT })
@Injectable()
export class CodeStatusState {

  constructor(private codeStatusService: CodeStatusService) {
  }

  @Selector()
  static codeStatusList(state: CodeStatusStateModel): CodeStatusStateModel['codeStatusList'] {
    return state.codeStatusList;
  }

  @Action(GetCodeStatusList)
  getCodeStatusList(ctx: StateContext<CodeStatusStateModel>, { filter }: GetCodeStatusList): void {
    this.codeStatusService.getCodeStatusList(filter).subscribe({
      next: (res) => {
        ctx.patchState({ codeStatusList: res.data });
      }
    });
  }
}


